import type { IconSvgObject } from './types';

const DraftingCompassIcon: IconSvgObject = [
  ["path", { d: "M10.5 7.50195L4 22.002M13.5 7.50195L15.5172 12.002M20 22.002L18.2069 18.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 4.00195L12 2.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "6.00195", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 12.002C4.99073 14.4213 8.27968 16.002 12 16.002C15.7203 16.002 19.0093 14.4213 21 12.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 14.502V17.502", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default DraftingCompassIcon;
